import { useCallback, useEffect, useState } from "react";
import { noop } from "lodash-es";
import { PAGE_IDS } from "src/shared/constants/PageIds";
import { HERO_BANNER_CONTENT_ID, OFFSET_HEIGHT } from "src/website-apps/shared/constants/header";
import { useWebNativeHeader } from "src/website-apps/shared/hooks/useWebNativeHeader";

export const getYOffset = (element: Element | null) => {
  const rect = element?.getBoundingClientRect();
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  return (rect?.top ?? 0) + scrollTop;
};

export const usePerformerNativeHeader = () => {
  const [isPastScrollThreshold, setIsPastScrollThreshold] = useState(false);

  const { showWebHeaderForNativeApp, handleWebHeaderBackClick } = useWebNativeHeader(PAGE_IDS.EVENT_LIST);

  const scrollHandler = useCallback(() => {
    const heightToHideFrom = getYOffset(document.querySelector(`#${HERO_BANNER_CONTENT_ID}`)) - OFFSET_HEIGHT;
    const winScroll = document.body.scrollTop || document.documentElement.scrollTop;

    if (winScroll > heightToHideFrom) {
      if (!isPastScrollThreshold) {
        // to limit setting state only the first time
        setIsPastScrollThreshold(true);
      }
    } else {
      setIsPastScrollThreshold(false);
    }
  }, [isPastScrollThreshold]);

  const listenToScroll = showWebHeaderForNativeApp ? scrollHandler : noop;

  useEffect(() => {
    window.addEventListener("scroll", listenToScroll);
    return () => {
      window.removeEventListener("scroll", listenToScroll);
    };
  }, [listenToScroll]);

  return {
    showWebHeaderForNativeApp,
    handleWebHeaderBackClick,
    isPastScrollThreshold,
  };
};
